<template>
  <div class="ybl-table" ref="ybl-table"
    :class="{'mutil-rows':$attrs.mutil,'nowrap':$attrs.nowrap,'newUI':$attrs.newUI}">
    <el-table :data="data" ref="table" v-bind="$attrs" v-on="$listeners">
      <slot></slot>
    </el-table>
    <div class="ybl-table__page" v-if="total>10">
      <ybl-pager :total="total" @change="change" :size="size" @size-change="sizeChange"
        :monitor="$attrs.monitor===undefined || !!$attrs.monitor"></ybl-pager>
    </div>
  </div>
</template>

<script>
export default {
  name: 'yblTable',
  props: {
    data: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number | String,
      default: 0
    },
    change: {
      type: Function,
      default: () => { }
    },
    size: {
      type: Number,
      default: () => 10
    }
  },
  data () {
    return {
      maxHeight: 500,
      pageSize: this.size || 10
    }
  },
  mounted () {
    //  :max-height="maxHeight"
    let height = document.documentElement.clientHeight
    this.$nextTick(() => {
      this.maxHeight = height - 180
    })
  },
  methods: {
    clearSelection () {
      this.$refs.table.clearSelection()
    },
    toggleRowSelection (rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.table.toggleRowSelection(row)
        })
      } else {
        this.clearSelection()
      }
    },
    toggleAllSelection () {
      this.$refs.table.toggleAllSelection()
    },
    sizeChange (item) {
      this.pageSize = item.size
      this.$emit('size-change', item)
    }
  }
}
</script>

<style lang="less">
@import "../assets/less/color.less";
.ybl-table {
  &__page {
    padding: 10px 0;
    text-align: right;
  }
  .el-button {
    padding: 0;
  }
  &.mutil-rows {
    .el-table__header {
      th {
        padding: 0;
        .cell {
          line-height: 16px;
        }
      }
    }
  }
  &.nowrap {
    .el-table__header {
      th .cell {
        white-space: nowrap;
      }
    }
  }
  &.newUI {
    .el-table__header {
      .el-table__cell {
        background-color: @secondary-border-color;
        height: 48px;
      }
    }
    .el-table__cell {
      height: 36px;
    }
  }
  .el-table__expanded-cell {
    padding: 0;
  }
  .el-table__placeholder {
    margin-right: 3px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Table.vue